import { DEVICE_HISTORY_FAIL, DEVICE_HISTORY_REQUEST, DEVICE_HISTORY_SUCCESS, DEVICE_LIST_FAIL, DEVICE_LIST_REQUEST, DEVICE_LIST_SUCCESS, DEVICE_LIVE_READING_FAIL, DEVICE_LIVE_READING_REQUEST, DEVICE_LIVE_READING_SUCCESS, DEVICE_READINGS_FAIL, DEVICE_READINGS_REQUEST, DEVICE_READINGS_SUCCESS } from "../constants/liveMonitorConstants";

const initialState = {
    loading: false,
    historyLoading: false,
    devices: [],
    readings: {},
    historicalReadings: [],
    error: null,
};

export const liveMonitorReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case DEVICE_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            }

        case DEVICE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                devices: action.payload,
                error: null
            }    
        
        case DEVICE_LIST_FAIL:
            return {
                ...state,
                loading: false,
                devices: [],
                error: action.payload
            }    

        case DEVICE_READINGS_REQUEST:
            return {
                ...state,
                loading: true,
            }    

        case DEVICE_READINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                readings: action.payload,
            };
            
        case DEVICE_READINGS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };    

        case DEVICE_HISTORY_REQUEST:
            return {
                ...state,
                historyLoading: true,
                error: null,
            };

        case DEVICE_HISTORY_SUCCESS:
            return {
                ...state,
                historyLoading: false,
                historicalReadings: action.payload,
                error: null,
            }  
            
        case DEVICE_HISTORY_FAIL:
            return {
                ...state,
                historyLoading: false,
                error: action.payload,
            };

        case DEVICE_LIVE_READING_REQUEST:
            return {
                ...state,
            };
        
        case DEVICE_LIVE_READING_SUCCESS:
            return {
                ...state,
                readings: {
                    ...state.readings,
                    [action.payload.deviceId]: action.payload.reading
                }
            }

        case DEVICE_LIVE_READING_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        default:
            return state;    
    }
}